import { Grid, Typography, Box, Stack } from "@mui/material";
import * as React from "react";
import iconImage from "../images/torch.png";

export default function PendingPage({ user }) {
  console.log("PENDING IS MY NAME AND PENDING IS MY GAME");

  return (
    <Box
      sx={{
        alignContent: "center",
        height: "95vh",
      }}
    >
      <Grid container>
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <Box
            sx={{
              display: "inline-block",
              backgroundColor: "foreground.main",
              backgroundSize: "cover",
              backgroundPosition: "center",
              borderRadius: "8px", // Optional: Rounded corners
              overflow: "hidden", // Ensure button stays inside box
              borderWidth: 2,
              borderColor: "#ffe8c0",
              borderStyle: "solid",
              p: 15,
            }}
          >
            <Stack>
              <img
                src={iconImage}
                alt="Ignite Insight"
                style={{
                  width: "100",
                  height: "100",
                  zIndex: "999",
                  alignSelf: "center",
                }}
              />
              <Typography
                sx={{
                  mt: 10,
                  alignSelf: "center",
                  textAlign: "center",
                  fontSize: 25,
                  cursor: user.user_type == 2 ? "pointer" : "default",
                }}
                onClick={() => {
                  if (user.user_type == 2) {
                    window.open("http://discord.gg/Cbv5k5Xt36");
                  }
                }}
              >
                {user.user_type == 2 ? (
                  <u>Click to Get Approval From An Admin On Discord</u>
                ) : user.user_type == 3 ? (
                  "Get Approval From Your Mentor"
                ) : (
                  "Your an Admin WHY ARE YOU NOT APPROVED?"
                )}
              </Typography>
            </Stack>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
